<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<well-office-address-info-message *ngIf='showOfficeAddressInfoMessage' />

<div class='address-picker' [ngClass]="{'map-float-right' : mapFloatRight}">

  <ng-container [formGroup]="form" *ngIf="showDetails ||  !displayAsString ">
    <div *ngIf="showAddressSearch">
      <well-address-search-box
        [allowSelection]='allowSelection()'
        [validateForDistance]="validateForDistance"
        [showMap]="!!form?.value?.address?.pointDTO && showMap"
        [showClear]="showClear"
        [initialValue]="initialValue"
        [searchLocal]="searchLocal"
        [required]="form.controls['address']?.invalid && form.controls['address']?.dirty"
        [searchOnGoolge]="searchOnGoolge"
        [mapFloatRight]="mapFloatRight"
        [mapHeight]="mapHeight"
        [disabled]="form.disabled"
        (addressSelect)="onAddressSelect($event)"
        (locationChanged)="onLocationChanged($event)" data-testid="address-search-box-search">
      </well-address-search-box>
    </div>


    <well-address-inputs
      [hideFieldsUntilInput]="hideFieldsUntilInput"
      [handoverAddress]="handoverAddress"
      [companyRequired]="companyRequired"
      [displayMainAddress]="displayMainAddress"
      [eTransportContext]='eTransportContext'
      [displayAdditionalFields]="displayAdditionalFields"
      formControlName="address"
      [addressTypes]="meta?.addressTypes | translateDropdownStringList: 'address.addressTypes'"
      [visibilityTypes]="meta?.visibilityTypes | translateDropdownStringList: 'address.visibilityTypes'"
      [displayTypeField]="displayTypeField"
      [displayVisibilityField]="displayVisibilityField"
      [touched]="form.touched"
      [displayAddressTemplateSave]="displayAddressTemplateSave"
      [dirty]="form.dirty"
      (addressTemplateSaved)='showMap = handoverAddress ?? false'
      [disableFieldsUntilInput]="disableFieldsUntilInput" data-testid="address-input"/>

    <div class=" pull-right" *ngIf="displayAsString">
      <button pButton *ngIf="!displayAsString" [disabled]="inputs.form.invalid || !form.value.address.postalCode"
              class="p-button-rounded"
              [label]="'address.utils.apply' | translate" (click)="apply()" data-testid="apply-btn">
      </button>
    </div>

  </ng-container>

  <well-address-as-string-view
    [editString]="editString"
    *ngIf="displayAsString && !showDetails"
    [externalAddressFormGroup]="form.controls['address'].value"
    (showDetails)="onShowDetailsClick($event)">
  </well-address-as-string-view>

</div>


